export default __webpack_public_path__ + "static/media/1525.a6f850e0.png";